module.exports = function () {
    var currentIndex;

    // owl carousel breakpoints
    var breakpoints = {
        0: {
            items: 1,
            stagePadding: 20
        },
        768: {
            items: 3,
            stagePadding: 50
        }
    };

    // owl carousel settings
    var owlCarouselSettings = {
        nav: false,
        dots: true,
        margin: 0,
        responsive: breakpoints,
        callbacks: true,
        onChanged: function (event) {
            var $el = $(event.target);
            
            var item = event.item.index;
            var items = event.item.count;

            var $prev = $el.parents('.featured-topic-list').find('.featured-topic-list__cta--prev');
            var $next = $el.parents('.featured-topic-list').find('.featured-topic-list__cta--next');

            if (item === 0) {
                $prev.addClass('featured-topic-list__cta--disabled');
                $next.removeClass('featured-topic-list__cta--disabled');
            }
            else if ((item + event.page.size) === items) {
                $prev.removeClass('featured-topic-list__cta--disabled');
                $next.addClass('featured-topic-list__cta--disabled');
            }
            else {
                $prev.removeClass('featured-topic-list__cta--disabled');
                $next.removeClass('featured-topic-list__cta--disabled');
            }
        }
    };

    // owl carousel initialization
    $('.featured-topic-list').each(function () {
        var $cards = $(this).find('.universal-grid.universal-grid--featured');
        $cards.on('initialized.owl.carousel', centerFeaturedCards);
        $cards.addClass('owl-carousel');
        $cards.owlCarousel(owlCarouselSettings);
        var $next = $(this).find('.featured-topic-list__cta--next');

        $next.click(function () {
            $cards.trigger('next.owl.carousel');
        });

        var $prev = $(this).find('.featured-topic-list__cta--prev');
        $prev.click(function () {
            $cards.trigger('prev.owl.carousel');
        });
    });

    // set appropriate settings per breakpoint per carousel
    var centerFeaturedCards = function () {
        var currentWidth = window.innerWidth;
        var currentBreakpointInfo = null;

        var breakpointKeys = Object.keys(breakpoints);
        for (var i in breakpointKeys) {
            if (breakpointKeys.hasOwnProperty(i) && breakpointKeys[i] <= currentWidth) {
                currentBreakpointInfo = breakpoints[breakpointKeys[i]];
            }
        }

        var numItems = currentBreakpointInfo.items;

        if (currentIndex !== numItems) {
            currentIndex = numItems;

            $('.featured-topic-list').each(function () {
                // Capture index of first active item, so we can move back to it.
                var activeItemIndex = $(this).find('.owl-item.active').first().index();
                var clonedItemIndexOffset = $(this).find('.owl-item.cloned').filter(function (index) { return $(this).index() <= activeItemIndex; }).length;

                if (clonedItemIndexOffset > 0) {
                    activeItemIndex = activeItemIndex - clonedItemIndexOffset;
                }

                var $cards = $(this).find('.universal-grid.universal-grid--featured');
                var cardsLength = $cards.find('.universal-grid-item').length;

                var $nav = $(this).find('.featured-topic-list__navigation');

                // is currently a carousel                
                if ($cards.hasClass('owl-loaded') && cardsLength <= numItems) {
                    $cards.owlCarousel('destroy');
                    $cards.removeClass('owl-carousel');

                    $nav.addClass('featured-topic-list__navigation--hidden');
                }
                else if (cardsLength > numItems) {
                    $cards.on('initialized.owl.carousel', centerFeaturedCards);
                    $cards.addClass('owl-carousel');
                    $cards.owlCarousel(owlCarouselSettings);
                    $nav.removeClass('featured-topic-list__navigation--hidden');
                }
            });
        }
    };

    $(window).resize(function () {
        setTimeout(centerFeaturedCards(), 200);
    });

    $(window).resize(); 
};